import {AfterViewInit, Component, ChangeDetectionStrategy} from '@angular/core';

declare const MathJax: {typeset: () => void};

@Component({
    selector: 'equation',
    templateUrl: 'equation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class EquationComponent implements AfterViewInit {
    public ngAfterViewInit(): void {
        this.initializeMath();
    }

    private initializeMath(): void {
        MathJax.typeset();
    }
}
